import { FilterQuery } from '@yes.technology/react-toolkit'

function getClonedFilterquery(filterquery: FilterQuery) {
  return JSON.parse(JSON.stringify(filterquery))
}

export default getClonedFilterquery
